export enum disclaimerTypes {
  WARNING = "warning",
  INFO = "info",
  ERROR = "error",
}
